import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { useMetricSuccessfulLoad } from '../hooks/useMetricSuccessfulLoad';
import { jsx as _jsx } from "react/jsx-runtime";
export const withRenderTimeMetrics = (WrappedComponent, metricName) => {
  const WithRenderTimeMetrics = _ref => {
    let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    useMetricSuccessfulLoad(metricName);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
  };
  WithRenderTimeMetrics.displayName = `WithRenderTimeMetrics(${WrappedComponent.displayName ? WrappedComponent.displayName : 'UnknownComponent'})`;
  return WithRenderTimeMetrics;
};